<template>
  <modal name="error-win-modal" class="popup_dialog error-win" :class="ifTop"
    transition="nice-modal-fade"
    :width="360"
    :min-width="360"
    :min-height="414"
    :height="414"
    :delay="100"
    :draggable="'.modal-header'"
    :clickToClose="false"
    :adaptive=true
    classes='q-v--modal'
    >
      <div class="modal-content" :style="{cursor: 'default'}">
        <div class="modal-header" >
          <div class="dialog-icon icon-warning"></div>
          <div class="dialog-header">{{(showErrorWin.title) ? showErrorWin.title: $t('warning')}}</div>
        </div>
        <div class="modal-body">
          <div class="dialog-content">
            <div class="dialog-message">{{dialogMessage}}</div>
        </div>
        </div>
        <div class="modal-footer">
          <div class="buttons">
            <div class="q-button blue-btn-full" @click="onClose">{{$t('ok')}}</div>
          </div>
        </div>
      </div>
  </modal>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'error-window',
  data () {
    return {
      modalname: 'error-win-modal',
      showModal: true
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    onOpen () {
      this.openModal('error-win-modal')
      this.$modal.show('error-win-modal')
    },
    onClose () {
      this.closeModal('error-win-modal')
      this.$modal.hide('error-win-modal')
    }
  },
  computed: {
    ...mapState({
      showErrorWin: state => state.module.showErrorWin
    }),
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    },
    dialogMessage () {
      // let me = this
      let result = ''
      let data = this.showErrorWin.data
      let config = this.showErrorWin.config
      let errCode = data.error_code
      if (errCode === undefined) {
        errCode = data.status
      }
      switch (errCode) {
        case -1:
        case -2:
        case -3:
        case -4:
        case -7:
        case -11:
        case -12:
        case -13:
          result = this.$t('updatefw.fwFailContent', {error_code: errCode})
          break
          // result = this.$t('updatefw.unAuthChange')
          // me.showErrorWin.title = this.$t('updatefw.fwFailTitle')
          // break
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          result = this.$t('errorMessage.snmperror', errCode)
          break
        case 5:
          result = this.$t('errorMessage.dnserror')
          if (config && config.url && config.url.includes('firmware/update/check')) {
            result = this.$t('errorMessage.networkError')
          }
          break
        case 6:
          result = this.$t('errorMessage.connectFail')
          break
        case 500:
          if (config && config.url && config.url.includes('firmware/update/check')) {
            result = this.$t('errorMessage.networkError')
          } else if (data.error_message && data.error_message.includes('file can\'t be modified!')) {
            result = this.$t('systemBackup.restoreError')
          } else {
            result = data.error_message
          }
          /*
           else if (data.error_message.includes('no route to host') || data.error_message.includes('Malformed version')) {
            result = this.$t('errorMessage.serverError')
          }
          */
          break
        default:
          if (data.error_message) {
            result = data
          }
          result = (data.error_message) ? data.error_message : this.$t('errorMessage.unknownError')
          break
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
@import '../assets/scss/modal.scss';

.error-win {
  .dialog-header {
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/errors.vue